export default __webpack_public_path__ + "static/media/p21.8c30af5a.jpg";